import axios from "axios";
import React from "react";

// const
const APPLICATION_ADD_INITIAL_DATA = "applicationAdd/APPLICATION_ADD_INITIAL_DATA";
const APPLICATION_ADD_UPDATE_DATA = "applicationAdd/APPLICATION_ADD_UPDATE_DATA";
const APPLICATION_ADD_STORE_APPLICATION_TERMINALS = "applicationAdd/APPLICATION_ADD_STORE_APPLICATION_TERMINALS";
const APPLICATION_ADD_STORE_APPLICATION_MODELS = "applicationAdd/APPLICATION_ADD_STORE_APPLICATION_MODELS";
const APPLICATION_ADD_STORE_APPLICATION_TYPES = "applicationAdd/APPLICATION_ADD_STORE_APPLICATION_TYPES";
const APPLICATION_ADD_STORE_APPLICATION_CATEGORY_TREE = "applicationAdd/APPLICATION_ADD_STORE_APPLICATION_CATEGORY_TREE";
const APPLICATION_ADD_TOGGLE_MODAL = "applicationAdd/APPLICATION_ADD_TOGGLE_MODAL";
const APPLICATION_ADD_TOGGLE_LOADING = "applicationAdd/APPLICATION_ADD_TOGGLE_LOADING";

// modal const
const APPLICATION_ADD_MODAL_SUCCESS_TITLE = "scenes_Application_ApplicationAdd_modal_success_title";
const APPLICATION_ADD_MODAL_FAIL_TITLE = "scenes_Application_ApplicationAdd_modal_fail_title";
const APPLICATION_ADD_MODAL_SUBMIT_SUCCESS_CONTENT = "scenes_Application_ApplicationAdd_modal_submitSuccess_content";
const APPLICATION_ADD_MODAL_SUBMIT_FAIL_CONTENT = "scenes_Application_ApplicationAdd_modal_submitFail_content";
const APPLICATION_ADD_MODAL_UPLOAD_FILE_SUCCESS_CONTENT = "scenes_Application_ApplicationAdd_modal_uploadFileSuccess_content";
const APPLICATION_ADD_MODAL_UPLOAD_FILE_FAIL_CONTENT = "scenes_Application_ApplicationAdd_modal_uploadFileFail_content";  //，是否重新上传？
const APPLICATION_ADD_MODAL_OK_LABEL = "scenes_Application_ApplicationAdd_modal_OK_label";
const APPLICATION_ADD_MODAL_CANCEL_LABEL = "scenes_Application_ApplicationAdd_modal_cancel_label";
const APPLICATION_ADD_MODAL_JUMP_LABEL = "scenes_Application_ApplicationAdd_modal_jump_label";
const APPLICATION_ADD_MODAL_RETURN_LABEL = "scenes_Application_ApplicationAdd_modal_return_label";
const APPLICATION_ADD_MODAL_YES_LABEL = "scenes_Application_ApplicationAdd_modal_yes_label";
const APPLICATION_ADD_MODAL_NO_LABEL = "scenes_Application_ApplicationAdd_modal_no_label";

// reducer
export const applicationAdd = (state = {
  loading: false,
  flag: "",

  modalVisible: false,
  modalTitle: "",
  modalContent: "",
  modalOk: "",
  modalCancel: "",
  onOk: null,
  onCancel: null,

  visibleLogo: false,
  previewLogo: "",
  logoImage: [],
  logo: "",

  applicationTerminals: [],
  applicationModels: [],
  applicationTypes: [],
  applicationCategoryTree: [],

}, action) => {
  switch (action.type) {
    case APPLICATION_ADD_INITIAL_DATA:
      return {
        ...state,
        flag: action.data.flag,

        modalVisible: false,
        modalTitle: "",
        modalContent: "",
        modalOk: "",
        modalCancel: "",
        onOk: null,
        onCancel: null,

        visibleLogo: false,
        previewLogo: "",
        logoImage: [],
        logo: "",
      };
    case APPLICATION_ADD_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case APPLICATION_ADD_STORE_APPLICATION_TERMINALS:
      return {
        ...state,
        applicationTerminals: action.data
      };
    case APPLICATION_ADD_STORE_APPLICATION_MODELS:
      return {
        ...state,
        applicationModels: action.data
      };
    case APPLICATION_ADD_STORE_APPLICATION_TYPES:
      return {
        ...state,
        applicationTypes: action.data
      };
    case APPLICATION_ADD_STORE_APPLICATION_CATEGORY_TREE:
      return {
        ...state,
        applicationCategoryTree: action.data
      };
    case APPLICATION_ADD_TOGGLE_MODAL:
      return {
        ...state,
        modalVisible: action.data.modalVisible,
        modalTitle: action.data.modalTitle,
        modalContent: action.data.modalContent,
        modalOk: action.data.modalOk,
        modalCancel: action.data.modalCancel,
        onOk: action.data.onOk,
        onCancel: action.data.onCancel
      };
    case APPLICATION_ADD_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    default:
      return state
  }
};

/**
 * update data based on user input
 */
export const updateApplicationData = (data) => {
  return {
    type: APPLICATION_ADD_UPDATE_DATA,
    data: data
  }
};

/**
 * initial data on load
 */
export const initialApplicationData = (data) => {
  return {
    type: APPLICATION_ADD_INITIAL_DATA,
    data: data
  }
};

/**
 * get all Application Terminal
 */
export const getApplicationTerminals = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getApplicationTerminal", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplicationTerminals(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all Application Terminals
 */
export const storeApplicationTerminals = (applicationTerminals) => {
  return {
    type: APPLICATION_ADD_STORE_APPLICATION_TERMINALS,
    data: applicationTerminals
  }
};

/**
 * get all Application Models
 */
export const getApplicationModels = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getApplicationModel", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplicationModels(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all Application Models
 */
export const storeApplicationModels = (applicationModels) => {
  return {
    type: APPLICATION_ADD_STORE_APPLICATION_MODELS,
    data: applicationModels
  }
};

/**
 * get all Application Types
 */
export const getApplicationTypes = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getApplicationType", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplicationTypes(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all Application Types
 */
export const storeApplicationTypes = (applicationTypes) => {
  return {
    type: APPLICATION_ADD_STORE_APPLICATION_TYPES,
    data: applicationTypes
  }
};

/**
 * get all Application category tree
 */
export const getApplicationCategoryTree = () => (dispatch) => {
  dispatch(toggleLoading(true));
  axios.get("/api-application/getApplicationCategoryTree", {contentType: "application/json"}).then(
    response => {
      if (response.data) {
        dispatch(storeApplicationCategoryTree(response.data));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * store all Application category tree
 */
export const storeApplicationCategoryTree = (applicationCategoryTree) => {
  return {
    type: APPLICATION_ADD_STORE_APPLICATION_CATEGORY_TREE,
    data: applicationCategoryTree
  }
};

/**
 * submit data
 */
export const submitApplication = (data, history, flag) => (dispatch) => {
  // dispatch(toggleLoading(true));
  axios({
    method: "post",
    url: "/api-application/submitApplication",
    contentType: "application/json",
    withCredentials: true,
    data: {
      "code": data.code,
      "name": data.name,
      "enName": data.enName,
      "logo": data.logo,
      "terminal": {"id": data.terminal},
      "model": {"id": data.model},
      "type": {"id": data.type},
      "parentCategory": {"id": data.category[0]},
      "category": {"id": data.category[1]},
      "status": {"code": data.status},
      "description": data.description,
      "createUserId": data.createUserId,
      "createUserName": data.createUserName,
      "createCompanyId": flag === "enterprise" ? data.createCompanyId : "00000000-0000-0000-0000-000000000000",
      "createCompanyName": (flag === "enterprise" ? data.createCompanyName : (flag === "platform" ? "中科云翼互联智造服务云平台" : (flag === "private" ? "" : data.createUserId))),
      "ifModule": false,
      "ifEnabled": true
    },
  }).then(
    response => {
      if (response.status === 200) {
        let applicationId = response.data.applicationId;
        console.log("success create new application");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_ADD_MODAL_SUCCESS_TITLE,
          modalContent: APPLICATION_ADD_MODAL_SUBMIT_SUCCESS_CONTENT,
          modalOk: APPLICATION_ADD_MODAL_JUMP_LABEL,
          modalCancel: APPLICATION_ADD_MODAL_RETURN_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            console.log(applicationId);
            history.push(`/console/application-edit?id=${applicationId}&flag=${flag}`);
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }));
            history.push(`/console/application-management-${flag}`);
          }
        }));
      } else {
        console.error("fail to create new application");
        dispatch(toggleModal({
          modalVisible: true,
          modalTitle: APPLICATION_ADD_MODAL_FAIL_TITLE,
          modalContent: APPLICATION_ADD_MODAL_SUBMIT_FAIL_CONTENT,
          modalOk: APPLICATION_ADD_MODAL_OK_LABEL,
          modalCancel: APPLICATION_ADD_MODAL_CANCEL_LABEL,
          onOk: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          },
          onCancel: () => {
            dispatch(toggleModal({
              modalVisible: false
            }))
          }
        }));
        dispatch(toggleLoading(false));
      }
    }
  );
};

/**
 * toggle modal
 */
export const toggleModal = (show) => {
  return {
    type: APPLICATION_ADD_TOGGLE_MODAL,
    data: show
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: APPLICATION_ADD_TOGGLE_LOADING,
    data: show
  }
};
